module.exports = __webpack_public_path__ + "img/advantage_1.3616824d.svg";